module.exports = __webpack_public_path__ + "img/1-3.56f914b0.png";